import { render, staticRenderFns } from "./MetaMaskLogin.vue?vue&type=template&id=0f9b90e6&scoped=true&"
import script from "./MetaMaskLogin.vue?vue&type=script&lang=js&"
export * from "./MetaMaskLogin.vue?vue&type=script&lang=js&"
import style0 from "./MetaMaskLogin.vue?vue&type=style&index=0&id=0f9b90e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b90e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})
